export const miraFlowStates = [
    'ready',
    'loading',
    'empty',
    'error',
    'saving',
    'deleting',
    'confirming',
    'streaming',
    'retrying',
    'pending',
    'success',
    'failed',
    'unavailable',
    'gated',
];
export const miraReturnRules = [
    { from: 'chat', fallback: 'today', preserveSource: true },
    { from: 'login', fallback: 'today', preserveSource: true },
    { from: 'register', fallback: 'today', preserveSource: true },
    { from: 'privacy', fallback: 'login', preserveSource: true },
    { from: 'terms', fallback: 'login', preserveSource: true },
];
export const miraGateRules = {
    authGate: {
        sheetId: 'auth-gate',
        closeExecutesAction: false,
        restoreDraftWithoutAutoSend: true,
        fallbackRouteId: 'today',
    },
};
export function safeReturnRoute(from, source) {
    if (source)
        return source;
    return miraReturnRules.find((rule) => rule.from === from)?.fallback ?? 'today';
}
